import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { MobileDetectorService } from "src/app/core/services/mobile-detector.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class OnlyMobileGuard {
  private readonly mobileDetectorService = inject(MobileDetectorService);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.mobileDetectorService.isMobile()
  }
}
